import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Agreement, borwserHistory, formatPeriodLabel, getProductInfo, getTeamConfig_POST_PAID_PROMISE_Enable, getTeamConfig_POST_PAID_PROMISE_Term, openOrderPay, } from '@zenlayer/portal-utils';
import { Button, Elevation, notification, Select, Space, Spin, Tag, Tooltip, Typography, } from '@zenlayer/zen-design';
import { calc } from '@zenlayer/zen-design/esm/_util/utils';
import t from '@zenlayer/zen-intl18';
import { useAsyncEffect, useControllableValue, useRequest } from 'ahooks';
import { useState } from 'react';
import { getDiscountTerms, getTermAgree, sendTermAgree, } from '../../api/priceInfo';
import { Summary } from '../summary';
import cls from './index.module.less';
import { useInsufficientBalanceModel } from './useInsufficientBalanceModel';
export const SubmitBox = ({ children }) => {
    return (_jsx(Elevation, { type: 5, shadow: false, borderRadius: false, className: cls.submitBox, children: children }));
};
export const PriceInfo = (props) => {
    const { serviceSn, productSn, productName, category, type, className, clauses, terms: terms_props, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    defaultTerm: _defaultTerm, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    term: _term, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onTermChange: _onTermChange, commitmentTermEnable: commitmentTermEnable_props, hidePromotionalText, termDisabled, summarySubTitle, onBack, onSubmit, handleSubmitResponse, handleSubmitSuccess, handleSubmitFailed, onPaySuccess, isLoading, submitDisabled, submitTooltips, handleSubmitRedirectUrl, dataAttrs, ...summaryProps } = props;
    const [historyHasAgreed, setHistoryHasAgreed] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [checked, setChecked] = useState(false);
    const GetTermAgreeRequest = useRequest(getTermAgree, {
        defaultParams: [
            {
                tag: productSn,
                category,
            },
        ],
        onSuccess({ data }) {
            if (data === true) {
                setHistoryHasAgreed(true);
            }
        },
    });
    const commitmentTermEnable = commitmentTermEnable_props ?? getTeamConfig_POST_PAID_PROMISE_Enable(); // 是否开启后付费承诺期
    const teamConfigPostTerm = getTeamConfig_POST_PAID_PROMISE_Term(); //teamConfig配置的承诺期
    const [term, onTermChange] = useControllableValue(props, {
        defaultValue: undefined,
        defaultValuePropName: 'defaultTerm',
        valuePropName: 'term',
        trigger: 'onTermChange',
    });
    const [terms, setTerms] = useState([]);
    const TermsRequest = useRequest(() => getDiscountTerms({ serviceSn, productSn, productName }, type), {
        manual: true,
        onSuccess: (res) => {
            if (res.success) {
                //
            }
            else {
                notification.error({ description: res.msg });
            }
        },
    });
    useAsyncEffect(async function* () {
        if (terms_props !== undefined) {
            setTerms(terms_props);
            return;
        }
        let terms;
        if (type === 'PREPAID' || (type === 'POSTPAID' && commitmentTermEnable)) {
            const { success, data } = await TermsRequest.runAsync();
            yield; // Check whether the effect is still valid, if it is has been cleaned up, stop at here.
            if (success) {
                terms = data?.filter((item) => type === 'PREPAID' //后付费根据配置取交集
                    ? true
                    : teamConfigPostTerm.includes(item.period));
            }
            else {
                terms = [];
            }
        }
        else {
            terms = [];
        }
        onTermChange(terms?.[0]?.period, terms?.[0]?.periodUnit);
        setTerms(terms);
    }, [type, terms_props]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const insufficientBalanceModel = useInsufficientBalanceModel();
    const productInfo = getProductInfo(serviceSn, productSn, productName);
    const handleSubmit = async () => {
        if (!checked) {
            setShowTooltip(true);
            return;
        }
        if (!historyHasAgreed) {
            sendTermAgree({
                tag: productSn,
            });
        }
        setSubmitLoading(true);
        if (onSubmit) {
            await onSubmit?.({ term });
            setSubmitLoading(false);
        }
        if (handleSubmitResponse) {
            const res = await handleSubmitResponse({ term });
            setSubmitLoading(false);
            // 成功
            if (res?.success) {
                // 自定义成功回调
                if (handleSubmitSuccess) {
                    handleSubmitSuccess(res);
                    return;
                }
                // 预付费
                if (type === 'PREPAID') {
                    openOrderPay(res.data.orderSn, {
                        onPaySuccess: onPaySuccess,
                    });
                    return;
                }
                // 后付费
                if (type === 'POSTPAID') {
                    const link = handleSubmitRedirectUrl;
                    if (link) {
                        borwserHistory.push(link, {});
                    }
                }
                notification.success();
            }
            else if (res?.code === 'ORDER_CHECK_AMOUNT_NOT_ENOUGH') {
                // 余额不足
                insufficientBalanceModel.open(res);
            }
            else if (res?.code === 'INVALID_QUOTA_EXCEED') {
                // 配额不足
                return;
            }
            else if (res?.code === 'STOCK_INSUFFICIENT') {
                // 库存不足
                notification.warning({
                    description: t('nyv2rT9vOQTr'),
                    message: t('ndpgPRE6Q4Qc'),
                });
                return;
            }
            else if (res) {
                // 自定义失败回调
                if (handleSubmitFailed) {
                    handleSubmitFailed(res);
                    return;
                }
                else {
                    // 错误提示
                    notification.error({ description: res?.msg });
                }
            }
        }
        setSubmitLoading(false);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Space, { block: true, direction: "vertical", size: "lll", className: className, children: [(type === 'PREPAID' ||
                        (type === 'POSTPAID' && commitmentTermEnable && !!terms?.length)) && (_jsxs(_Fragment, { children: [_jsx(Typography, { title: type === 'PREPAID' ? t('KWbrJmx64HGg') : t('SxiQLyYSgDQ1'), subtitle: type === 'PREPAID' ? t('JMds3gb9f0AU') : t('QdXQ38uudgU6'), children: _jsxs("div", { className: cls.termBox, children: [_jsx(Select, { ...dataAttrs?.period, disabled: termDisabled, value: term, onChange: (v, { unit }) => {
                                                onTermChange(v, unit);
                                            }, loading: TermsRequest.loading, optionsLoading: TermsRequest.loading, type: "filled", children: terms.map((item) => {
                                                const { period, periodUnit, strength } = item;
                                                return (_jsx(Select.Option, { value: period, unit: periodUnit, children: _jsxs(Space, { size: 4, children: [_jsx("span", { children: formatPeriodLabel(period, periodUnit) }), strength > 0 && (_jsx(Tag, { sale: true, type: "warning", style: { display: 'flex' }, children: t('slUkOB6k6Gvl', [calc.mul(100, strength)]) }))] }) }, period));
                                            }) }), !hidePromotionalText && terms.some((i) => i.strength > 0) && (_jsx(Tag, { type: "warning", children: t('YAa0DBoiPy68') }))] }) }), _jsx("div", { className: cls.divider })] })), _jsx(Summary, { type: type, isLoading: TermsRequest.loading || isLoading, subTitle: summarySubTitle, ...summaryProps })] }), _jsx(SubmitBox, { children: _jsx(Spin, { spinning: GetTermAgreeRequest.loading, children: _jsxs(Space, { direction: "vertical", block: true, children: [_jsx(Agreement, { ...dataAttrs?.agreement, clauses: clauses, historyHasAgreed: historyHasAgreed, showTooltip: showTooltip, checked: checked, onChange: (checked) => {
                                    if (checked) {
                                        setChecked(true);
                                        setShowTooltip(false);
                                    }
                                    else {
                                        setChecked(false);
                                        setShowTooltip(true);
                                    }
                                } }), _jsx(Tooltip, { title: submitTooltips ? submitTooltips : undefined, placement: "bottom", children: _jsx(Button, { ...dataAttrs?.submit, special: true, width: "100%", disabled: submitDisabled, loading: submitLoading, onClick: handleSubmit, htmlType: "submit", children: t('9B8K1yTM0JB2') }) }), !!onBack && (_jsx(Button, { ...dataAttrs?.back, width: "100%", type: "text", onClick: onBack, children: t('wpQy5HKyPaPT') }))] }) }) })] }));
};
